import { RouteUnpublishedChangesDiscardedDtoModelType } from '../../models';
import getAppRoot from '../../utils/getAppRoot';
import getAppEnv from '../../utils/getAppEnv';
import { Pages } from '../../Router/constants';
import { unpublishedChangesDiscardedNotification } from '../../../../notifications/routes/unpublishedChangesDiscarded';

const driverNameOf = (route: { driver?: { name?: string | null } | null }): string | undefined => {
  try {
    const name = route.driver?.name?.trim();
    return name || undefined;
  } catch {
    return undefined;
  }
};

/**
 * Unpublished planner changes were discarded because the route completed. Tell the planner either
 * way — the edits were accepted at the time and otherwise they believe they can still republish.
 *
 * The subscription payload carries identity, the driver name, and unpublishedChanges (chip / Publish). Restoring
 * the published stop set is a RouteOverview fetch, and only when that route is already on screen:
 * stuffing overview into the subscription would make every workspace subscriber pay for a fat
 * payload, and calendar refresh would no-op when the calendar is closed anyway — calendar summary
 * also does not include stops, so it would not change.
 */
export default ({ route, store }: RouteUnpublishedChangesDiscardedDtoModelType) => () => {
  const rootStore = getAppRoot(store);

  if (route?.uuid != null) {
    const { uuid } = route;
    getAppEnv(store).notification(unpublishedChangesDiscardedNotification(
      uuid,
      driverNameOf(route),
      () => {
        rootStore.router.navigateToRouteResource(
          { routeUuid: uuid },
          { targetPage: Pages.SCHEDULING, deselectStop: true, deselectOrder: true },
        );
      },
    ));
  }

  if (route?.uuid == null) {
    return;
  }

  const isSelected = rootStore.ui.selectedRoute?.id === route.id;
  const isOnSelectedDate = rootStore.sortedRoutes.some((visible) => visible.uuid === route.uuid);

  if (isSelected || isOnSelectedDate) {
    rootStore.model.fetchRouteByUuid(route.uuid);
  }
};
